module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/371.686f2e18.png";